<template>
  <div class="main_box">
    <div class="body_title flex_layout_between">
      <h2>{{ $t('enum.shipsFrom') }}</h2>
    </div>
    <div class="">
      <el-form ref="form" v-loading="loading" :model="formDetail">
        <div class="store_box">
          <div class="store_title">{{ $t('enum.country') }}</div>
          <el-select class="store_ipt" v-model="Country">
            <el-option v-for="item in CountryList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="store_box">
          <div class="store_title">{{ $t('enum.countryState') }}</div>
          <el-select class="store_ipt" v-if="StateList.length" v-model="State" filterable data-live-search="true">
            <el-option v-for="(item, key) in StateList" :key="key" :label="item.EName" :value="item.EName"></el-option>
          </el-select>
        </div>

        <div class="store_box store_btn_box">
          <div class="store_btn" @click="$router.push({ name: 'store', params: { getTabNum: 1 } });">{{ $t('button.cancel') }}</div>
          <div :class="['store_btn', 'primary', OldState == State && !CanSaveAgain ? 'disabled' : '']" @click="getData('EditStoreShipment')">{{ $t('button.save') }}</div>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      loading: false,
      UserDetail: {},
      MemberSource: "",
      dialogVisible: false,
      CountryList: ['US'],
      Country: 'US',//America
      StateList: [], //州列表
      State: '',
      CanSaveAgain: true,//相同数据是否可以上传
      OldState: '',//用户原本数据不可提交用
      formDetail: {}
    }
  },
  mounted() {
    var that = this;
    let UserDetail = JSON.parse(that.$cookie.get('Card_Seller_UserDetail'));

    let UserDtl = JSON.parse(that.$cookie.get('Card_Seller_USERDTL'));
    let MemberSource=UserDtl.MemberSource;
    that.MemberSource = MemberSource;
    that.CountryList = [MemberSource];

    that.UserDetail = UserDetail;
    that.Country = MemberSource;//UserDetail.Country;
    that.State = UserDetail.State;
    // console.log("UserDetail",UserDetail);
    that.OldState = UserDetail.State;

    // that.getData("GetChinaArea");//获取用户所属区域
    that.getData("GetAreasByCode","?code="+MemberSource);//获取用户所属区域
  },
  watch: {
    FormData: {
      handler(fd) {
        this.FormDataWatch(1);
      },
      deep: true,
    }
  },
  methods: {
    getData(api, data = "") {
      var that = this;
      var fun = "", method = "GET";
      switch (api) {
        case "GetChinaArea": //获取国内所有省直辖市
          that.$get(api, data)
            .then((res) => {
              // console.log("axios-res:", api, res);
              if (res.result) {
                var _data = res.data;
                that.StateList = _data;
              }
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case "GetAreasByCode": //根据code获取区域
          that.$get(api, data)
            .then((res) => {
              // console.log("axios-res:", api, res);
              if (res.result||res.Result) {
                var _data = res.Data;
                that.StateList = _data;
              }
            })
            .catch((err) => {
              console.log(err);
            });
          break;
        case "EditStoreShipment": //保存发货地
          if (that.OldState == that.State && !that.CanSaveAgain) {
            return false;
          }
          if (that.loading) {
            return false;
          }
          that.loading = true;
          data = { Country: that.Country, State: that.State, 'UserApi': 'UserApi', }
          that.$post(api, data)
            .then((res) => {
              // console.log("axios-res:", api, res);
              if (res.Result) {
                that.$message({
                  showClose: true,
                  message: res.Msg || 'Save Success',
                  type: "success",
                });
                that.getData('GetMemberInfo');
                that.$router.push({ name: "store", params: { getTabNum: 1 } })
              }
              that.loading = false;
            })
            .catch((err) => {
              console.log(err);
              that.loading = false;
            });
          break;
        case 'GetMemberInfo': //通过用户id获取用户详情
          that.loading = true;
          that.$get('GetMemberInfo', `?MemberId=${that.$store.state.UserInfo.Id}`, 'UserApi')
            .then((ress) => {
              console.log("axios-GetMemberInfo:", ress);
              if (ress.Result) {
                that.OldState = ress.Data.State;
                that.$store.state.UserDetail = ress.Data;
                that.$cookie.set('Card_Seller_UserDetail', JSON.stringify(ress.Data), {
                  expires: that.$store.state.exdays
                });
              } else {
                // that.$message.error('Login failed');
              }
              that.loading = false;
            })
            .catch((err) => {
              console.log(err);
              that.loading = false;
            });
          break;
        default:
          break;
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/allstore.css";

.store_box {
  width: 30%;
  margin-right: 40px;
}

.store_box:nth-child(3) {
  margin-right: 0;
}

.store_ipt {
  width: 100%;
}

.store_origin {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/pages/store/origin.vue